import type { TextClasses, TextTags } from './interfaces';
import cn from 'classnames';
import { forwardRef, Ref } from 'react';

export interface TextProps {
    tag: TextTags;
    variant?: TextClasses;
    className?: string;
    children?: React.ReactNode | React.ReactNode[];
    id?: string;
    tabIndex?: number;
    style?: { [index: string]: string | number };
    role?: string;
    ariaLabel?: string;
    dataCy?: string;
}

export const Text = forwardRef(function (props: TextProps, ref: Ref<HTMLElement>): React.JSX.Element {
    const Tag = props.tag;
    const tagClasses = cn(props.className, {
        [props.variant as string]: props.variant,
    });

    return (
        <Tag
            id={props.id}
            tabIndex={props.tabIndex}
            className={tagClasses}
            style={props.style}
            role={props.role}
            aria-label={props.ariaLabel}
            data-cy={props?.dataCy}
            ref={ref as Ref<HTMLHeadingElement>}
        >
            {props.children}
        </Tag>
    );
});

Text.displayName = 'Text';
